import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {clientsServicesService, ManageClientService} from '@store/clients/services';
import {Button, Stack, Typography} from '@mui/material';
import React, {useState} from 'react';
import {Sizes} from '@constants/sizes.constants';
import {FilterBaseEntityEnum, filtersService} from '@store/filters';
import {TableFilterType} from '@store/common/tableFilter.model';
import {map} from 'rxjs';
import AsyncSelectWithSearchComponent from '@components/inputs/asyncSelect/AsyncSelectWithSearch.component';
import {SelectItem} from '@components/inputs/select/Select.component';
import {checkIfErrors, FieldValidationType, getFieldError} from '@utils/yup.utils';
import ModalComponent from '@components/modal/Modal.component';
import {LoadingButton} from '@mui/lab';
import DatePickerComponent from '@components/inputs/datePicker/DatePicker.component';

interface UpdateKindModalProps {
  handleClose: () => void;
  service: ManageClientService;
  onSave: () => void;
}

const UpdateKindModal = (props: UpdateKindModalProps) => {
  const {handleClose, service, onSave} = props;
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [newKind, setNewKind] = useState<SelectItem | undefined>(service.kind);
  const [fromDate, setFromDate] = useState<Date | undefined>(undefined);

  const errors = {
    newKind: getFieldError(newKind, FieldValidationType.REQUIRED_SELECT_ITEM),
    fromDate: getFieldError(fromDate, FieldValidationType.REQUIRED_DATE),
  };

  const handleSave = () => {
    setLoading(true);
    if (service.id && newKind && newKind.value !== service.kind?.value && fromDate) {
      clientsServicesService.updateKind(service.id, newKind.value, fromDate)
        .subscribe({
          next: (res) => {
            enqueueSnackbar(t('clients.details.contractedServices.manage.updateKind.success'), {variant: 'success'});
            onSave();
          },
          error: (err) => enqueueSnackbar(err.text, err.options),
        });
      // executionLineService.fixPrices(service.id, {from, to, sellPrice, buyPrice})
      //   .subscribe({
      //     next: (res) => {
      //       enqueueSnackbar(t('clients.details.contractedServices.manage.fixPrices.updatedCount', {count: res.updatedCount}), {variant: 'success'});
      //       handleClose();
      //     },
      //     error: (err) => enqueueSnackbar(err.text, err.options),
      //
      //   });
    }

  };

  return <ModalComponent
    aria-label="over-drawer"
    handleClose={handleClose}
    title={t('clients.details.contractedServices.manage.updateKind.title')}
    content={(
      <Stack direction="column" width="70%" spacing={2} pt="55px" pb="10px">
        <Typography textAlign="center">
          {t('clients.details.contractedServices.manage.updateKind.description')}
        </Typography>
        <AsyncSelectWithSearchComponent
          labelWidth={Sizes.drawerInputLabelWidth}
          color="secondary"
          label={t('clients.details.contractedServices.manage.serviceKind')}
          placeholder={t('global.selectOptions')}
          handleChange={(kind) => setNewKind(kind)}
          required
          error={errors.newKind}
          value={newKind}
          getOptions={(search) => filtersService.getFilters(TableFilterType.SERVICE_KIND, FilterBaseEntityEnum.NONE, [], search).pipe(
            map((options) => options.map((o) => ({label: o.name || '-', value: o.id})))
          )}/>
        <DatePickerComponent
          label={t('clients.details.contractedServices.manage.fromDate')}
          placeholder={t('global.selectDate')}
          color="secondary"
          value={fromDate}
          handleChange={(validFromDate) => {
            setFromDate(validFromDate);
          }}
          error={errors.fromDate}/>
      </Stack>
    )}
    actions={(
      <>
        <Button
          variant="outlined"
          onClick={handleClose}
          color="primary">
          {t('global.cancel')}
        </Button>
        <LoadingButton
          variant="contained"
          disabled={checkIfErrors(errors) && newKind?.value != service.kind?.value}
          loading={loading}
          onClick={handleSave}
          color="primary">
          {t('global.save')}
        </LoadingButton>
      </>
    )}
  />;
};

export default UpdateKindModal;
